exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".wangEditor-menu-container{background-color:#353942}.wangEditor-menu-container .menu-group{border-right-color:#292c33}.wangEditor-menu-container .menu-item a{color:#abacae}.wangEditor-container{border-color:#292c33}.content-container .content{margin-top:0;margin-left:0;padding:0}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/vue-loader/lib/style-rewriter.js!./~/vue-loader/lib/selector.js?type=style&index=0!./src/views/article_add.vue
 ** module id = 146
 ** module chunks = 0
 **/